<template>
  <div id="new-lgb-team-members-list">
    <v-card elevation="3" class="rounded-lg">
      <!-- Header Section -->
      <v-card-title class="primary darken-1 white--text py-3">
        <div class="d-flex flex-column flex-grow-1">
          <h2 class="mb-2">{{ PageTitle }} {{ NextYearName }}</h2>
          <h4 class="font-weight-regular">
            {{ PageDescription }} {{ NextYearName }}
          </h4>
        </div>

        <v-btn
          elevation="2"
          color="white"
          class="font-weight-medium px-4"
          @click.prevent="refreshPageData"
        >
          <v-icon left>mdi-refresh</v-icon>
          Refresh
        </v-btn>
      </v-card-title>
      <!-- Floating Action Button -->
      <v-container class="py-0" v-if="floatButtonFlag">
        <v-speed-dial
          v-if="floatButtonFlag"
          v-model="fab"
          :top="top"
          :bottom="bottom"
          :right="right"
          :left="left"
          :direction="direction"
          :open-on-hover="hover"
          :transition="transition"
          :fixed="true"
        >
          <template v-slot:activator>
            <v-btn v-model="fab" color="primary" dark fab>
              <v-icon v-if="fab"> mdi-close </v-icon>
              <v-icon v-else> mdi-account-circle </v-icon>
            </v-btn>
          </template>
          <v-tooltip left>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                fab
                small
                color="indigo"
                @click.prevent="addRecordPrompt = true"
                v-bind="attrs"
                v-on="on"
              >
                <v-icon>mdi-account-plus</v-icon>
              </v-btn>
            </template>
            <span>Assign member</span>
          </v-tooltip>
          <v-tooltip left v-if="addJcrtButtonFlag">
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                fab
                small
                color="success"
                @click.prevent="OpenNewMemberDialog(1)"
                v-bind="attrs"
                v-on="on"
              >
                <v-icon>mdi-account-star</v-icon>
              </v-btn>
            </template>
            <span>Add Jcrt member</span>
          </v-tooltip>
          <v-tooltip left>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                fab
                small
                color="info"
                @click.prevent="OpenNewMemberDialog(2)"
                v-bind="attrs"
                v-on="on"
              >
                <v-icon>mdi-account-child</v-icon>
              </v-btn>
            </template>
            <span>Add JrJc member</span>
          </v-tooltip>
        </v-speed-dial>
      </v-container>

      <!-- Dialogs -->
      <v-dialog v-model="addRecordPrompt" persistent max-width="80%">
        <new-lgb-team-members-modify
          pageDescription="Assign LO Governing board members for the year"
          :addRecordPrompt="addRecordPrompt"
          @hideAddRecordPrompt="hideAddRecordPrompt($event)"
          v-if="addRecordPrompt"
        ></new-lgb-team-members-modify>
      </v-dialog>

      <v-dialog v-model="editRecordPrompt" persistent max-width="80%">
        <new-lgb-team-members-edit
          pageDescription="Edit LO Governing board members for the year"
          :editRecordPrompt="editRecordPrompt"
          :recordData="selectedData"
          @hideEditRecordPrompt="hideEditRecordPrompt"
          v-if="editRecordPrompt"
        ></new-lgb-team-members-edit>
      </v-dialog>

      <v-dialog v-model="memberDocumentPrompt" persistent scrollable>
        <add-member-document
          pageTitle="Add Member Document"
          pageDescription="Add Member Document"
          :showDialog="memberDocumentPrompt"
          @hideDialog="hideMemberDocumentPrompt"
          v-if="memberDocumentPrompt"
        ></add-member-document>
      </v-dialog>

      <v-dialog v-model="uploadDocumentPrompt" persistent max-width="70%">
        <add-lom-document
          pageTitle="Upload Nomination committee report"
          pageDescription="Upload Nomination committee report"
          :addRecordPrompt="uploadDocumentPrompt"
          @hideAddRecordPrompt="hideUploadRecordPrompt($event)"
          v-if="uploadDocumentPrompt"
        ></add-lom-document>
      </v-dialog>

      <v-dialog v-model="createRecordPrompt" persistent scrollable>
        <create-new-member
          :pageDescription="NewMemberPageDescription"
          :MemberType="NewMemberType"
          :addRecordPrompt="createRecordPrompt"
          @hideAddRecordPrompt="hideCreateRecordPrompt($event)"
          v-if="createRecordPrompt"
        ></create-new-member>
      </v-dialog>

      <v-dialog
        eager
        v-model="previewRecordPrompt"
        v-if="PreviewButtonFlag && Documentpath != ''"
      >
        <v-app-bar
          color="primary"
          dense
          dark
          elevate-on-scroll
          scroll-target="#scrolling-techniques-7"
        >
          <v-toolbar-title>Nomination List</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-btn icon @click="hidePreviewRecordPrompt">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-app-bar>
        <iframe
          id="ifrm"
          :src="Documentpath"
          v-if="PreviewButtonFlag && Documentpath != ''"
          width="100%"
          height="500px"
        ></iframe>
        <v-card v-if="!PreviewButtonFlag" width="100%" height="500px">
          <v-row wrap>
            <v-col cols="12" md="12" align="center">
              <h1 class="text-danger">File not found.</h1>
            </v-col>
          </v-row>
        </v-card>
      </v-dialog>

      <v-card-text>
        <!-- Loading Spinner -->
        <div class="d-flex justify-center my-4" v-if="LoadingFlag">
          <v-progress-circular
            indeterminate
            color="primary"
            size="70"
            width="7"
          >
            Loading
          </v-progress-circular>
        </div>

        <!-- Download Info -->
        <div class="d-flex">
          <div style="max-width: 500px; width: 100%">
            <v-alert
              variant="outlined"
              density="comfortable"
              color="grey lighten-1"
              border="start"
              icon="mdi-information"
              class="my-4 rounded-lg pa-4 d-flex align-center"
            >
              <div class="text-body-1">
                Please download&nbsp;
                <a
                  :href="SampleFilePath"
                  target="_blank"
                  download
                  class="font-weight-medium text-info text-decoration-underline"
                >
                  Nomination committee report
                </a>
                &nbsp;here.
              </div>
            </v-alert>
          </div>
        </div>

        <!-- Action Buttons -->
        <v-card class="mb-6 pa-3" outlined>
          <v-row align="center">
            <v-col cols="12" sm="12" md="12" lg="7">
              <div class="d-flex flex-wrap">
                <v-btn
                  class="mr-2 mb-2"
                  color="success"
                  @click.prevent="addRecordPrompt = true"
                >
                  <v-icon left>mdi-account-multiple-plus</v-icon>
                  Assign Member
                </v-btn>

                <v-btn
                  class="mr-2 mb-2"
                  color="deep-purple"
                  @click.prevent="memberDocumentPrompt = true"
                  v-if="MemberDocumentFlag"
                >
                  <v-icon left>mdi-file-upload</v-icon>
                  Upload Age Proof Document
                </v-btn>

                <v-btn
                  v-if="Flag"
                  class="mr-2 mb-2"
                  color="orange darken-1"
                  @click.prevent="OpenNewMemberDialog(2)"
                >
                  <v-icon left>mdi-account-child</v-icon>
                  Add Jr. Jc Member
                </v-btn>

                <v-btn
                  class="mr-2 mb-2 text-white"
                  color="teal"
                  @click.prevent="uploadDocumentPrompt = true"
                >
                  <v-icon left>mdi-file-document-outline</v-icon>
                  Upload Nomination committee report
                </v-btn>

                <v-btn
                  class="mr-2 mb-2"
                  color="teal"
                  @click.prevent="uploadRecordPrompt = true"
                  v-if="CreateButtonFlag"
                >
                  <v-icon left>mdi-file-upload-outline</v-icon>
                  Upload Nomination Report
                </v-btn>

                <v-btn
                  class="mr-2 mb-2"
                  color="amber darken-2"
                  @click.prevent="previewRecordPrompt = true"
                  v-if="PreviewButtonFlag && Documentpath != ''"
                >
                  <v-icon left>mdi-eye</v-icon>
                  Preview Report
                </v-btn>
              </div>
            </v-col>

            <v-col cols="12" sm="12" md="12" lg="5">
              <v-card
                outlined
                class="elevation-0 pa-4 rounded-lg d-flex align-center justify-space-between"
              >
                <div class="d-flex align-center">
                  <v-icon color="primary" class="mr-2"
                    >mdi-file-document-outline</v-icon
                  >
                  <h4 class="mb-0 font-weight-medium">
                    Nomination committee report Upload Status
                  </h4>
                </div>

                <v-chip
                  :color="Documentpath ? 'success' : 'warning'"
                  label
                  class="font-weight-medium text-white"
                  variant="flat"
                >
                  <v-icon left>
                    {{ Documentpath ? "mdi-check-circle" : "mdi-alert-circle" }}
                  </v-icon>
                  {{ Documentpath ? "Completed" : "Pending" }}
                </v-chip>
              </v-card>
            </v-col>
          </v-row>
        </v-card>

        <!-- Team Members Grid -->
        <v-container class="py-0" v-if="rows.length > 0">
          <v-card outlined class="pa-3 mb-4">
            <h3
              class="text-h5 font-weight-medium text-center mb-4 primary--text"
            >
              LO Governing Board Members
            </h3>

            <v-data-iterator
              :items="rows"
              :items-per-page="-1"
              hide-default-footer
            >
              <template v-slot:default="props">
                <v-row>
                  <v-col
                    v-for="item in props.items"
                    :key="item.MemberId"
                    cols="12"
                    sm="6"
                    md="3"
                    lg="2"
                  >
                    <v-card
                      class="member-card"
                      elevation="3"
                      :class="{ inactive: item.ActiveStatus != 1 }"
                    >
                      <div class="d-flex justify-center">
                        <v-avatar size="120" class="ma-4">
                          <v-img
                            :src="item.ProfilePic"
                            :alt="item.MemberFullname"
                          />
                        </v-avatar>
                      </div>

                      <v-card-text class="text-center pa-2">
                        <h5 class="font-weight-bold mb-1">
                          {{ item.MemberFullname }} <br />
                          {{ item.MembershipId }}
                        </h5>
                        <div class="primary--text font-weight-medium">
                          {{ item.DesignationName }}
                        </div>

                        <v-divider class="my-2"></v-divider>

                        <div class="d-flex justify-center align-center">
                          <v-chip
                            x-small
                            :color="getActiveStatusColor(item.ActiveStatusTxt)"
                            dark
                            class="mr-2"
                          >
                            {{ item.ActiveStatusTxt }}
                          </v-chip>

                          <v-btn
                            v-if="
                              item.DesignationId != '' &&
                              editFlag &&
                              item.ActiveStatus != 1
                            "
                            icon
                            color="error"
                            x-small
                            @click="editData(item)"
                          >
                            <v-icon>mdi-pencil</v-icon>
                          </v-btn>
                        </div>
                      </v-card-text>
                    </v-card>
                  </v-col>
                </v-row>
              </template>
            </v-data-iterator>
          </v-card>
        </v-container>

        <!-- Important Notes Section -->
        <v-card outlined class="pa-4 mb-4">
          <div class="d-flex align-center mb-4">
            <v-icon color="amber darken-3" large class="mr-2">mdi-alert</v-icon>
            <h3 class="font-weight-bold mb-0 amber--text text--darken-3">
              Important Notes
            </h3>
          </div>

          <v-list dense class="pa-0">
            <v-list-item three-line>
              <v-list-item-icon class="mt-3">
                <v-icon color="primary">mdi-checkbox-marked-circle</v-icon>
              </v-list-item-icon>
              <v-list-item-content>
                <v-list-item-title>Active Member Requirement</v-list-item-title>
                <v-list-item-subtitle class="text-wrap">
                  As per Article 4.2 of policy manual part 2, all elective post
                  members should be active members.
                </v-list-item-subtitle>
              </v-list-item-content>
            </v-list-item>

            <v-list-item three-line>
              <v-list-item-icon class="mt-3">
                <v-icon color="primary">mdi-checkbox-marked-circle</v-icon>
              </v-list-item-icon>
              <v-list-item-content>
                <v-list-item-title>Age Proof Document</v-list-item-title>
                <v-list-item-subtitle class="text-wrap">
                  All the elective officers should upload their age proof
                  document under their members profile update page.
                </v-list-item-subtitle>
              </v-list-item-content>
            </v-list-item>

            <v-list-item three-line>
              <v-list-item-icon class="mt-3">
                <v-icon color="primary">mdi-checkbox-marked-circle</v-icon>
              </v-list-item-icon>
              <v-list-item-content>
                <v-list-item-title>Member Assignment</v-list-item-title>
                <v-list-item-subtitle class="text-wrap">
                  To assign LGB members for the next year click on
                  <span class="px-2 py-1 success white--text rounded"
                    >Assign Members</span
                  >
                  button.
                </v-list-item-subtitle>
              </v-list-item-content>
            </v-list-item>

            <v-list-item v-if="addJcrtButtonFlag" three-line>
              <v-list-item-icon class="mt-3">
                <v-icon color="primary">mdi-checkbox-marked-circle</v-icon>
              </v-list-item-icon>
              <v-list-item-content>
                <v-list-item-title>Jayceert Wing Members</v-list-item-title>
                <v-list-item-subtitle class="text-wrap">
                  To create Jayceert Wing member, click on
                  <span class="px-2 py-1 success white--text rounded"
                    >Add Jcrt Member</span
                  >
                  button and after that assign them using the "Assign Members"
                  button.
                </v-list-item-subtitle>
              </v-list-item-content>
            </v-list-item>

            <v-list-item three-line v-if="Flag">
              <v-list-item-icon class="mt-3">
                <v-icon color="primary">mdi-checkbox-marked-circle</v-icon>
              </v-list-item-icon>
              <v-list-item-content>
                <v-list-item-title
                  >Junior Jaycee Wing Members</v-list-item-title
                >
                <v-list-item-subtitle class="text-wrap">
                  To create Junior Jaycee wing member, click on
                  <span class="px-2 py-1 orange darken-1 white--text rounded"
                    >Add Jr. Jc Member</span
                  >
                  button.
                </v-list-item-subtitle>
              </v-list-item-content>
            </v-list-item>
            <v-list-item three-line>
              <v-list-item-icon class="mt-3">
                <v-icon color="primary">mdi-checkbox-marked-circle</v-icon>
              </v-list-item-icon>
              <v-list-item-content>
                <v-list-item-title
                  >Nomination Committee Chairman Report</v-list-item-title
                >
                <v-list-item-subtitle class="text-wrap">
                  Upload the Nomination Committee Chairman Report.
                </v-list-item-subtitle>
              </v-list-item-content>
            </v-list-item>
          </v-list>
        </v-card>
      </v-card-text>
    </v-card>
  </div>
</template>

<script>
import common from "@/view/Common.vue";
import companyConfig from "@/company_config.json";
import { SET_BREADCRUMB } from "@/core/services/store/breadcrumbs.module";
import {
  ADD_BODY_CLASSNAME,
  REMOVE_BODY_CLASSNAME,
} from "@/core/services/store/htmlclass.module.js";
import NewLgbTeamMembersModify from "@/view/pages/erp/team-members/new-lgb/NewLgbTeamMembersModify.vue";
import NewLgbTeamMembersEdit from "@/view/pages/erp/team-members/new-lgb/NewLgbTeamMembersEdit.vue";
import AddLomDocument from "@/view/pages/erp/team-members/new-lgb/AddLomDocument.vue";
import AddMemberDocument from "@/view/pages/members/AddMemberDocument.vue";
import CreateNewMember from "@/view/pages/erp/team-members/new-lgb/CreateNewMember.vue";

export default {
  mixins: [common],
  components: {
    NewLgbTeamMembersModify,
    NewLgbTeamMembersEdit,
    AddLomDocument,
    AddMemberDocument,
    CreateNewMember,
  },
  data() {
    return {
      valid1: true,
      valid2: true,
      LoadingFlag: false,
      SearchFlag: false,
      SubmitFlag: false,
      ResultFlag: false,
      dialog: false,
      rows: [],
      tableSelectFlag1: false,
      tableColumns1: [],
      selected: [],
      search: "",
      CurrentYearId: 0,

      refreshButtonFlag: false,
      floatButtonFlag: false,

      direction: "top",
      fab: true,
      fling: false,
      hover: true,
      tabs: null,
      top: false,
      right: true,
      bottom: true,
      left: false,
      transition: "slide-y-reverse-transition",

      editFlag: false,
      addJcrtButtonFlag: false,

      createRecordPrompt: false,
      NewMemberType: "",
      NewMemberPageDescription: "",

      CreateButtonFlag: false,
      PreviewButtonFlag: false,

      TooltipShowFlag: true,

      selectedData: {},
      addRecordPrompt: false,
      editRecordPrompt: false,
      previewRecordPrompt: false,
      uploadRecordPrompt: false,
      uploadDocumentPrompt: false,

      memberDocumentPrompt: false,
      MemberDocumentFlag: false,

      Documentpath: "",

      zone: {},
      lom: {},

      name: "",
      nameRules: [
        (v) => !!v || "Name is required",
        (v) => (v && v.length <= 10) || "Name must be less than 10 characters",
      ],
      email: "",
      emailRules: [
        (v) => !!v || "E-mail is required",
        (v) => /.+@.+\..+/.test(v) || "E-mail must be valid",
      ],
      select: "Item 1",
      items: ["Item 1", "Item 2", "Item 3", "Item 4"],
      checkbox: false,

      FromZoneCodeRules: [(v) => !!v || "Zone is required"],
      FromZoneCode: "",
      FromZoneCodeOptions: [],
      FromZoneCodeOptionsLoading: false,

      FromLomCodeRules: [(v) => !!v || "LO is required"],
      FromLomCode: "",
      FromLomCodeOptions: [],
      FromLomCodeOptionsLoading: false,

      ToZoneCodeRules: [(v) => !!v || "Zone is required"],
      ToZoneCode: "",
      ToZoneCodeOptions: [],
      ToZoneCodeOptionsLoading: false,

      ToLomCodeRules: [(v) => !!v || "LO is required"],
      ToLomCode: "",
      ToLomCodeOptions: [],
      ToLomCodeOptionsLoading: false,

      SearchId: "",
      SearchIdRules: [(v) => !!v || "Search Type is required"],
      SearchIdOptions: [
        { value: "", text: "--Select Type--" },
        { value: 1, text: "By LO" },
        { value: 2, text: "By Membership Id" },
      ],

      MembershipId: "",
      MembershipIdRules: [(v) => !!v || "Membership Id is required"],

      YearHalfId: "",
      YearHalfIdRules: [(v) => !!v || "Year Half is required"],
      YearHalfIdOptions: [
        { value: "", text: "--Select Half--" },
        { value: "First", text: "First Half" },
        { value: "Second", text: "Second Half" },
      ],

      YearIdRules: [(v) => !!v || "Year is required"],
      YearId: "",
      YearIdOptions: [],
      YearIdOptionsLoading: false,

      ApprovalDescription: "",
      ApprovalDescriptionRules: [],

      SampleFilePath: "",

      PageInfo: {},
      PageTitle: "",
      PageDescription: "",
      JciYearCode: "",
      YearName: "",
      NextYearCode: "",
      NextYearName: "",
    };
  },
  mounted() {
    /*
    this.$store.dispatch(SET_BREADCRUMB, [
      { title: "Vuetify", route: "alerts" },
      { title: "Form Inputs & Control", route: "autocompletes" },
      { title: "Fileinptus" },
    ]);
    */
  },
  watch: {
    SearchId: function () {
      console.log("watch SearchId");
      this.rows = [];
    },
    PageInfo: function () {
      console.log("watch PageInfo");
      this.LoadingFlag = false;
      var tr = this.PageInfo;
      console.log({ tr });
      var n1 = Object.keys(tr).length;
      console.log({ n1 });
      if (n1 > 0) {
        var flag = tr.PagePermissionFlag;
        console.log("PagePermissionFlag=" + flag);

        if (!flag) {
          this.$router.push("/access-denied");
        }
        this.PageTitle = tr.PageTitle;
        this.PageDescription = tr.PageDescription;

        var CurrentJciYearId = parseInt(tr.CurrentJciYearId);
        console.log({ CurrentJciYearId });
        this.JciYearCode = CurrentJciYearId;

        var YearName = parseInt(tr.CurrentJciYearName);
        console.log({ YearName });
        this.YearName = YearName;

        var NextJciYearId = parseInt(tr.NextJciYearId);
        console.log({ NextJciYearId });
        this.NextYearCode = NextJciYearId;

        var NextJciYearName = parseInt(tr.NextJciYearName);
        console.log({ NextJciYearName });
        this.NextYearName = NextJciYearName;

        this.CurrentYearId = NextJciYearId;

        var LomId = this.$session.get("LomId");
        LomId = LomId == (null || undefined) ? "" : LomId;
        this.LomCode = LomId;

        var server_url = companyConfig.apiURL;
        console.log("server_url = " + server_url);
        var SampleFilePath =
          server_url + "assets/sample/nomination_committee_report.pdf";
        console.log("SampleFilePath = " + SampleFilePath);
        this.SampleFilePath = SampleFilePath;

        this.pageData();
      }
    },
  },
  methods: {
    refreshPageData() {
      console.log("refreshPageData called");
      this.LoadingFlag = true;
      var url1 = "api/menu-details/show";
      var condition1 = {
        UserInterface: 1,
        Module: "lgb_dis",
        Action: "list",
      };
      this.getPageDetails("PageInfo", {}, url1, condition1);
    },
    pageData() {
      console.log("pageData called");
      this.getTableRecords();
      this.getDocumentRecords();
    },
    // code 1
    validate() {
      if (this.$refs.form2.validate()) {
        this.snackbar = true;
      }
    },
    hideAddRecordPrompt(flag) {
      console.log("hideAddRecordPrompt called");
      console.log({ flag });
      this.addRecordPrompt = false;
      if (flag) {
        this.getTableRecords();
      }
    },
    hideMemberDocumentPrompt() {
      console.log("hideMemberDocumentPrompt called");
      this.memberDocumentPrompt = false;
    },
    hideEditRecordPrompt(flag) {
      console.log("hideEditRecordPrompt called");
      console.log({ flag });
      this.editRecordPrompt = false;
      if (flag) {
        this.getTableRecords();
      }
    },
    hidePreviewRecordPrompt() {
      console.log("hidePreviewRecordPrompt called");
      this.previewRecordPrompt = false;
    },
    hideUploadRecordPrompt(flag) {
      console.log("hideUploadRecordPrompt called");
      console.log({ flag });
      this.uploadDocumentPrompt = false;
      if (flag) {
        this.getDocumentRecords();
      }
    },
    resetForm() {
      this.search = "";
      this.rows = [];
      this.selected = [];
      this.$refs.form3.reset();
    },
    resetValidation() {
      this.$refs.form2.resetValidation();
    },
    OpenNewMemberDialog(id) {
      console.log("OpenNewMemberDialog called id=" + id);
      var NewMemberType = "";
      var NewMemberPageDescription = "";
      switch (id) {
        case 1:
          // Jayceert Wing

          NewMemberType = 8;
          NewMemberPageDescription = "Add member for Jayceert Wing";
          break;

        case 2:
          // Junior Jaycee Wing

          NewMemberType = 9;
          NewMemberPageDescription = "Add member for Junior Jaycee Wing";
          break;

        default:
          break;
      }
      console.log(
        "NewMemberType=" +
          NewMemberType +
          ", NewMemberPageDescription=" +
          NewMemberPageDescription
      );
      this.NewMemberType = NewMemberType;
      this.NewMemberPageDescription = NewMemberPageDescription;
      this.createRecordPrompt = true;
    },
    hideCreateRecordPrompt(flag) {
      console.log("hideCreateRecordPrompt called");
      console.log({ flag });
      this.createRecordPrompt = false;
      if (flag) {
        this.getTableRecords();
      }
    },
    editData(tr) {
      console.log("editData called");
      var n1 = Object.keys(tr).length;
      console.log("n1=" + n1 + ", tr=" + JSON.stringify(tr));
      if (n1 > 0) {
        this.selectedData = tr;
        this.editRecordPrompt = true;
        /*
        var url = "/members/subscription/assign";
        console.log("id=" + id);
        var params = {
          id: id,
        };
        this.pageRedirect(params, url);
        */
      } else {
        var message = "Kindly select one member to edit";
        this.toast("error", message);
      }
    },
    getTableRecords() {
      console.log("getTableRecords called");

      var LomCode = this.$session.get("LomId");
      LomCode = LomCode == (null || undefined) ? "" : LomCode;
      console.log("LomCode=" + LomCode);

      var CurrentYearId = this.CurrentYearId;
      console.log("CurrentYearId=" + CurrentYearId);

      if (LomCode != null && CurrentYearId > 0) {
        var server_url = companyConfig.apiURL;
        var token = this.$session.get("token");
        token = token == (null || undefined) ? 0 : token;
        var add_url = server_url + "api/year-wise-designation/lists";
        var upload = {
          UserInterface: 1,
          OrganizationTypeId: 3,
          LomCode: LomCode,
          YearCode: CurrentYearId,
          ExceptDesignationId: [1, 5, 7],
          DirectoryInformationFlag: true,
        };
        console.log("upload=" + JSON.stringify(upload));
        console.log(
          "server_url=" +
            server_url +
            ", token=" +
            token +
            ", add_url=" +
            add_url
        );

        const thisIns = this;
        var output = "";
        var records = "";
        var successTxt = "";
        var errorTxt = "";
        var flag = 0;

        this.rows = [];
        this.ResultFlag = false;
        this.LoadingFlag = true;

        this.$http({
          url: add_url,
          method: "POST",
          data: upload,
          headers: {
            "Content-Type": "application/json",
            Authorization: "Bearer " + token,
          },
          onUploadProgress: function (progressEvent) {
            this.uploadPercentage = parseInt(
              Math.round((progressEvent.loaded / progressEvent.total) * 100)
            );
          }.bind(this),
        })
          .then(function (response) {
            console.log("response=" + JSON.stringify(response));

            thisIns.ResultFlag = true;
            thisIns.LoadingFlag = false;

            output = response.data.output;
            flag = response.data.flag;
            output = response.data.output;
            records = response.data.records;
            console.log("output=" + output + ", flag=" + flag);
            successTxt = response.data.success;
            errorTxt = response.data.error;
            console.log("successTxt=" + successTxt + ", errorTxt=" + errorTxt);

            if (flag == 1) {
              thisIns.rows = records.TableData;
              thisIns.tableColumns1 = records.TableHeader;
              thisIns.tableSelectFlag1 = records.TableSelectFlag;
              thisIns.editFlag = records.TableEditFlag;
              thisIns.MemberDocumentFlag = records.MemberDocumentFlag;
              thisIns.toast("success", output);
            } else {
              thisIns.toast("error", output);
            }
          })
          .catch(function (error) {
            console.log("error=" + error);
            thisIns.toast("error", error);
            thisIns.ResultFlag = true;
            thisIns.LoadingFlag = false;
          });
      } else {
        var message = "Your session is expired. Kindly login again. ";
        console.log("error=" + message);
      }
    },
    getDocumentRecords() {
      console.log("getDocumentRecords called");

      var LomCode = this.$session.get("LomId");
      LomCode = LomCode == (null || undefined) ? "" : LomCode;
      console.log("LomCode=" + LomCode);

      var CurrentYearId = this.CurrentYearId;
      console.log("CurrentYearId=" + CurrentYearId);

      if (LomCode != null && CurrentYearId > 0) {
        var server_url = companyConfig.apiURL;
        var token = this.$session.get("token");
        token = token == (null || undefined) ? 0 : token;
        var add_url = server_url + "api/lom-document/show";
        var upload = {
          UserInterface: 1,
        };
        console.log("upload=" + JSON.stringify(upload));
        console.log(
          "server_url=" +
            server_url +
            ", token=" +
            token +
            ", add_url=" +
            add_url
        );

        const thisIns = this;
        var output = "";
        var records = "";
        var flag = 0;

        this.LoadingFlag = true;
        this.Documentpath = "";

        this.$http({
          url: add_url,
          method: "POST",
          data: upload,
          headers: {
            "Content-Type": "application/json",
            Authorization: "Bearer " + token,
          },
          onUploadProgress: function (progressEvent) {
            this.uploadPercentage = parseInt(
              Math.round((progressEvent.loaded / progressEvent.total) * 100)
            );
          }.bind(this),
        })
          .then(function (response) {
            console.log("response=" + JSON.stringify(response));

            thisIns.LoadingFlag = false;

            output = response.data.output;
            flag = response.data.flag;
            records = response.data.records;
            var options = response.data.options;
            console.log("output=" + output + ", flag=" + flag);

            // thisIns.CreateButtonFlag = TableOptions.CreateButtonFlag;
            // thisIns.PreviewButtonFlag = TableOptions.PreviewButtonFlag;

            if (flag == 1) {
              var Documentpath = records.DocumentAssetPath;
              console.log("Documentpath=" + Documentpath);
              thisIns.Documentpath = Documentpath;
              // thisIns.toast("success", output);
            } else {
              // thisIns.toast("error", output);
            }
          })
          .catch(function (error) {
            console.log("error=" + error);
            thisIns.toast("error", error);
            thisIns.LoadingFlag = false;
          });
      } else {
        var message = "Your session is expired. Kindly login again. ";
        console.log("error=" + message);
      }
    },
  },
  beforeMount() {
    this.refreshPageData();
  },
};
</script>

<style lang="scss">
#new-lgb-team-members-list {
  .v-btn--floating {
    position: relative;
  }

  .v-speed-dial--bottom {
    bottom: 12%;
  }

  .v-speed-dial--right {
    right: 5%;
  }

  .member-card {
    position: relative;
    overflow: hidden;
    transition: all 0.3s ease;
    border-radius: 8px;

    &:hover {
      transform: translateY(-5px);
      box-shadow: 0 10px 20px rgba(0, 0, 0, 0.19), 0 6px 6px rgba(0, 0, 0, 0.23) !important;
    }

    &.inactive {
      opacity: 0.7;
    }

    .position-chip {
      position: absolute;
      top: 8px;
      right: 8px;
      z-index: 1;
    }
  }

  .notes-title {
    font-size: 1.2rem;
    font-weight: bold;
    line-height: 1.8em;
    color: #333;
  }

  .notes-content {
    font-size: 1rem;
    line-height: 1.8em;
    color: #555;

    li {
      margin-bottom: 10px;
    }
  }
}
</style>